module.exports = __webpack_public_path__ + "media/bootstrap-icons/hash-2c54e022.svg";